import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { default as default2 } from "./Sidebar.js";
import { default as default3 } from "./SidebarContent.js";
import { default as default4 } from "./SidebarFooter.js";
import { default as default5 } from "./SidebarGroup.js";
import { default as default6 } from "./SidebarGroupAction.js";
import { default as default7 } from "./SidebarGroupContent.js";
import { default as default8 } from "./SidebarGroupLabel.js";
import { default as default9 } from "./SidebarHeader.js";
import { default as default10 } from "./SidebarInput.js";
import { default as default11 } from "./SidebarInset.js";
import { default as default12 } from "./SidebarMenu.js";
import { default as default13 } from "./SidebarMenuAction.js";
import { default as default14 } from "./SidebarMenuBadge.js";
import { default as default15 } from "./SidebarMenuButton.js";
import { default as default16 } from "./SidebarMenuItem.js";
import { default as default17 } from "./SidebarMenuSkeleton.js";
import { default as default18 } from "./SidebarMenuSub.js";
import { default as default19 } from "./SidebarMenuSubButton.js";
import { default as default20 } from "./SidebarMenuSubItem.js";
import { default as default21 } from "./SidebarProvider.js";
import { default as default22 } from "./SidebarRail.js";
import { default as default23 } from "./SidebarSeparator.js";
import { default as default24 } from "./SidebarTrigger.js";
import { useSidebar } from "./utils.js";
const sidebarMenuButtonVariants = cva(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-primary data-[active=true]:font-medium data-[active=true]:text-primary-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
export {
  default2 as Sidebar,
  default3 as SidebarContent,
  default4 as SidebarFooter,
  default5 as SidebarGroup,
  default6 as SidebarGroupAction,
  default7 as SidebarGroupContent,
  default8 as SidebarGroupLabel,
  default9 as SidebarHeader,
  default10 as SidebarInput,
  default11 as SidebarInset,
  default12 as SidebarMenu,
  default13 as SidebarMenuAction,
  default14 as SidebarMenuBadge,
  default15 as SidebarMenuButton,
  default16 as SidebarMenuItem,
  default17 as SidebarMenuSkeleton,
  default18 as SidebarMenuSub,
  default19 as SidebarMenuSubButton,
  default20 as SidebarMenuSubItem,
  default21 as SidebarProvider,
  default22 as SidebarRail,
  default23 as SidebarSeparator,
  default24 as SidebarTrigger,
  sidebarMenuButtonVariants,
  useSidebar
};
//# sourceMappingURL=index.js.map
